<template>
  <div class="bui-nav-item-extra" :class="{ narrow }">
    <NavItem
      :to="to"
      :label="label"
      :narrow="narrow"
      class="primary"
    >
      <template #icon><slot name="icon" /></template>
    </NavItem>
    <button
      type="button"
      class="side-action"
      :class="{ 'side-action--narrow': narrow }"
      :aria-label="actionLabel"
      :title="actionLabel"
      data-testid="nav-logout"
      @click="emit('action')"
    >
      <NavIco :size="navIcoSize">
        <slot name="action-icon" />
      </NavIco>
    </button>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import NavItem from '../NavItem/NavItem.vue';
import NavIco from '../../atoms/NavIco/NavIco.vue';
import useIsMobile from '@/composables/utils/isMobile';

const isMobile = useIsMobile();
const navIcoSize = computed(() => (isMobile.value ? 32 : 40));

withDefaults(
  defineProps<{
    label: string;
    to?: string;
    narrow?: boolean;
    actionLabel?: string;
  }>(),
  { narrow: false, actionLabel: 'Action' },
);

const emit = defineEmits<{ action: [] }>();
</script>

<style lang="scss" scoped>
.bui-nav-item-extra {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;

  .primary {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;

    :deep(.label) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .side-action {
    display: inline-flex;
    align-items: center;
    border: 0;
    background: transparent;
    color: var(--nav-label-primary, #f6f7ff);
    padding: var(--nav-padding-box, 8px);
    border-radius: var(--nav-radius-box, 12px);
    cursor: pointer;
    flex-shrink: 0;
    position: relative;
    z-index: 1;

    &:hover {
      background: var(--nav-btn-hover, #8e3fbc);
    }

    &:focus-visible {
      outline: 2px solid var(--nav-label-primary, #f6f7ff);
      outline-offset: 2px;
    }
  }

  &.narrow {
    .primary {
      flex: 0 0 auto;
    }

    .side-action--narrow {
      padding: var(--nav-padding-box, 8px);
    }
  }
}
</style>
